import styled from "styled-components";
import { colors } from "../element/elements.js";

export const Styles = styled.div`
.mobile-fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1002;
  }

  .mobile-header-spacer {
    height: 96px; /* space for fixed header (adjust if needed) */
  }

.top-btn {
  background: linear-gradient(90deg, #ff6f6f, #d9251c);
  color: #fff;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.mobile-marquee {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  color: #fff;
}

.marquee-track {
  display: inline-block;
  animation: marquee 12s linear infinite;
}

.marquee-track span {
  margin-right: 30px;
}

@keyframes marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
}

.hamburger {
  font-size: 26px;
  background: none;
  border: none;
  color: #fff;
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  right: -280px;
  width: 280px;
  height: 100vh;
  background: #29155E;
  transition: right 0.3s ease;
  z-index: 1001;
}

.mobile-sidebar.open {
  right: 0;
}

.sidebar-header {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  font-size: 22px;
  background: none;
  border: none;
  color: #fff;
}

.sidebar-links {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
}

.sidebar-links a {
  color: #fff;
  text-decoration: none;
  padding: 12px 0;
  font-size: 15px;
  border-bottom: 1px solid rgba(255,255,255,0.15);
}

.mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1000;
}

.mobile-overlay.show {
  opacity: 1;
  pointer-events: all;
}

.sidebar-dropdown {
  color: #fff;
  font-size: 15px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255,255,255,0.15);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-submenu {
  padding-left: 12px;
  background: rgba(255,255,255,0.05);
}

.sidebar-submenu a {
  font-size: 14px;
  padding: 10px 0;
  display: block;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}


`;